import { render, staticRenderFns } from "./leftColSobreD.vue?vue&type=template&id=33e264dc&scoped=true"
import script from "./leftColSobreD.vue?vue&type=script&lang=js"
export * from "./leftColSobreD.vue?vue&type=script&lang=js"
import style0 from "./leftColSobreD.vue?vue&type=style&index=0&id=33e264dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e264dc",
  null
  
)

export default component.exports